const suburItems = [
    {
        name: 'Acton',
        lat: -35.2759,
        lng: 149.1143,
        postcode: '2601'
    }, {
        name: 'Ainslie',
        lat: -35.2617,
        lng: 149.1418,
        postcode: '2602'
    }, {
        name: 'Amaroo',
        lat: -35.1674,
        lng: 149.1279,
        postcode: '2914'
    }, {
        name: 'Aranda',
        lat: -35.2564,
        lng: 149.0772,
        postcode: '2614'
    }, {
        name: 'Banks',
        lat: -35.4700,
        lng: 149.0978,
        postcode: '2906'
    }, {
        name: 'Barton',
        lat: -35.3090,
        lng: 149.1335,
        postcode: '2600'
    }, {
        name: 'Belconnen',
        lat: -35.2359,
        lng: 149.0580,
        postcode: '2617'
    }, {
        name: 'Bonner',
        lat: -35.1583,
        lng: 149.1418,
        postcode: '2914'
    }, {
        name: 'Bonython',
        lat: -35.4322,
        lng: 149.0783,
        postcode: '2905'
    }, {
        name: 'Booroomba',
        lat: -35.5571,
        lng: 148.9921,
        postcode: '2620'
    }, {
        name: 'Braddon',
        lat: -35.2708,
        lng: 149.1346,
        postcode: '2612'
    }, {
        name: 'Bruce',
        lat: -35.2421,
        lng: 149.0904,
        postcode: '2617'
    }, {
        name: 'Calwell',
        lat: -35.4388,
        lng: 149.1060,
        postcode: '2905'
    }, {
        name: 'Campbell',
        lat: -35.2900,
        lng: 149.1532,
        postcode: '2612'
    }, {
        name: 'Casey',
        lat: -35.1661,
        lng: 149.0969,
        postcode: '2913'
    }, {
        name: 'Chapman',
        lat: -35.3562,
        lng: 149.0398,
        postcode: '2611'
    }, {
        name: 'Charnwood',
        lat: -35.1981,
        lng: 149.0356,
        postcode: '2615'
    }, {
        name: 'Chifley',
        lat: -35.3536,
        lng: 149.0765,
        postcode: '2606'
    }, {
        name: 'Chisholm',
        lat: -35.4190,
        lng: 149.1252,
        postcode: '2905'
    }, {
        name: 'City',
        lat: -35.2802,
        lng: 149.1310,
        postcode: '2601'
    }, {
        name: 'Conder',
        lat: -35.4572,
        lng: 149.1014,
        postcode: '2906'
    }, {
        name: 'Cook',
        lat: -35.2596,
        lng: 149.0642,
        postcode: '2614'
    }, {
        name: 'Coombs',
        lat: -35.3172,
        lng: 149.0401,
        postcode: '2611'
    }, {
        name: 'Crace',
        lat: -35.2017,
        lng: 149.1072,
        postcode: '2911'
    }, {
        name: 'Curtin',
        lat: -35.3244,
        lng: 149.0818,
        postcode: '2605'
    }, {
        name: 'Duffy',
        lat: -35.3380,
        lng: 149.0319,
        postcode: '2611'
    }, {
        name: 'Farrer',
        lat: -35.3762,
        lng: 149.1018,
        postcode: '2607'
    }, {
        name: 'Forde',
        lat: -35.1708,
        lng: 149.1441,
        postcode: '2914'
    }, {
        name: 'Fyshwick',
        lat: -35.3233,
        lng: 149.1694,
        postcode: '2609'
    }, {
        name: 'Gordon',
        lat: -35.4550,
        lng: 149.0870,
        postcode: '2906'
    }, {
        name: 'Gungahlin',
        lat: -35.1802,
        lng: 149.1277,
        postcode: '2912'
    }, {
        name: 'Hawker',
        lat: -35.247,
        lng: 149.042,
        postcode: '2614'
    }, {
        name: 'Hughes',
        lat: -35.33269000,
        lng: 149.09491000,
        postcode: '2605'
    }, {
        name: 'Jacka',
        lat: -35.1501,
        lng: 149.1301,
        postcode: '2914'
    }, {
        name: 'Latham',
        lat: -35.2189,
        lng: 149.0315,
        postcode: '2615'
    }, {
        name: 'Macarthur',
        lat: -35.40535,
        lng: 149.1307,
        postcode: '2904'
    }, {
        name: 'McKellar',
        lat: -35.2170,
        lng: 149.0740,
        postcode: '2617'
    }, {
        name: 'Moncrieff',
        lat: -35.1565,
        lng: 149.1143,
        postcode: '2914'
    }, {
        name: 'Oaks Estate',
        lat: -35.3415,
        lng: 149.2279,
        postcode: '2620'
    }, {
        name: 'Page',
        lat: -35.2402,
        lng: 149.0521,
        postcode: '2614'
    }, {
        name: 'Phillip',
        lat: -35.3491,
        lng: 149.0899,
        postcode: '2606'
    }, {
        name: 'Richardson',
        lat: -35.428,
        lng: 149.11375,
        postcode: '2905'
    }, {
        name: 'Spence',
        lat: -35.1995,
        lng: 149.066,
        postcode: '2615'
    }, {
        name: 'Tharwa',
        lat: -35.5095,
        lng: 149.0691,
        postcode: '2620'
    }, {
        name: 'Turner',
        lat: -35.2669,
        lng: 149.1236,
        postcode: '2612'
    }, {
        name: 'Weetangera',
        lat: -35.2486,
        lng: 149.0497,
        postcode: '2614'
    }, {
        name: 'Yarralumla',
        lat: -35.3048,
        lng: 149.1069,
        postcode: '2600'
    }, {
        name: 'Deakin',
        lat: -35.3188,
        lng: 149.1065,
        postcode: '2600'
    }, {
        name: 'Dunlop',
        lat: -35.1945,
        lng: 149.0185,
        postcode: '2615'
    }, {
        name: 'Fisher',
        lat: -35.3619,
        lng: 149.0564,
        postcode: '2611'
    }, {
        name: 'Forrest',
        lat: -35.3144,
        lng: 149.1296,
        postcode: '2603'
    }, {
        name: 'Garran',
        lat: -35.3415,
        lng: 149.1086,
        postcode: '2605'
    }, {
        name: 'Gowrie',
        lat: -35.4134,
        lng: 149.1085,
        postcode: '2904'
    }, {
        name: 'Hackett',
        lat: -35.2486,
        lng: 149.1636,
        postcode: '2602'
    }, {
        name: 'Higgins',
        lat: -35.2330,
        lng: 149.0274,
        postcode: '2615'
    }, {
        name: 'Hume',
        lat: -35.3938,
        lng: 149.1632,
        postcode: '2620'
    }, {
        name: 'Kaleen',
        lat: -35.2248,
        lng: 149.1110,
        postcode: '2617'
    }, {
        name: 'Lawson',
        lat: -35.2277,
        lng: 149.0876,
        postcode: '2617'
    }, {
        name: 'Macgregor',
        lat: -35.2102,
        lng: 149.0120,
        postcode: '2615'
    }, {
        name: 'Melba',
        lat: -35.2097,
        lng: 149.0551,
        postcode: '2615'
    }, {
        name: 'Narrabundah',
        lat: -35.3348,
        lng: 149.1474,
        postcode: '2604'
    }, {
        name: "Oconnor",
        lat: -35.2589,
        lng: 149.1153,
        postcode: '2602'
    }, {
        name: 'Palmerston',
        lat: -35.1959,
        lng: 149.1155,
        postcode: '2913'
    }, {
        name: 'Pialligo',
        lat: -35.3072,
        lng: 149.1809,
        postcode: '2609'
    }, {
        name: 'Rivett',
        lat: -35.3493,
        lng: 149.0370,
        postcode: '2611'
    }, {
        name: 'Stirling',
        lat: -35.3487,
        lng: 149.0494,
        postcode: '2611'
    }, {
        name: 'Theodore',
        lat: -35.4496,
        lng: 149.1215,
        postcode: '2905'
    }, {
        name: 'Wanniassa',
        lat: -35.3986,
        lng: 149.0915,
        postcode: '2903'
    }, {
        name: 'Weston',
        lat: -35.3337,
        lng: 149.0621,
        postcode: '2611'
    }, {
        name: 'Dickson',
        lat: -35.2518,
        lng: 149.1399,
        postcode: '2602'
    }, {
        name: 'Evatt',
        lat: -35.2108,
        lng: 149.0691,
        postcode: '2617'
    }, {
        name: 'Florey',
        lat: -35.2263,
        lng: 149.0559,
        postcode: '2615'
    }, {
        name: 'Franklin',
        lat: -35.1986,
        lng: 149.1448,
        postcode: '2913'
    }, {
        name: 'Gilmore',
        lat: -35.4179,
        lng: 149.1360,
        postcode: '2905'
    }, {
        name: 'Greenway',
        lat: -35.4164,
        lng: 149.0630,
        postcode: '2900'
    }, {
        name: 'Hall',
        lat: -35.1675,
        lng: 149.0680,
        postcode: '2618'
    }, {
        name: 'Holder',
        lat: -35.33585,
        lng: 149.04497,
        postcode: '2611'
    }, {
        name: 'Isaacs',
        lat: -35.3677,
        lng: 149.1125,
        postcode: '2607'
    }, {
        name: 'Kambah',
        lat: -35.3864,
        lng: 149.0615,
        postcode: '2902'
    }, {
        name: 'Lyneham',
        lat: -35.2405,
        lng: 149.1259,
        postcode: '2602'
    }, {
        name: 'Macquarie',
        lat: -35.2477,
        lng: 149.0590,
        postcode: '2614'
    }, {
        name: 'Mitchell',
        lat: -35.2155,
        lng: 149.1416,
        postcode: '2911'
    }, {
        name: 'Ngunnawal',
        lat: -35.1709,
        lng: 149.1101,
        postcode: '2913'
    }, {
        name: "O'Malley",
        lat: -35.3527,
        lng: 149.1087,
        postcode: '2606'
    }, {
        name: 'Parkes',
        lat: -35.3007,
        lng: 149.13,
        postcode: '2600'
    }, {
        name: 'Red Hill',
        lat: -35.32436,
        lng: 149.1125,
        postcode: '2603'
    }, {
        name: 'Russell',
        lat: -35.2967,
        lng: 149.1498,
        postcode: '2600'
    }, {
        name: 'Swinger Hill',
        lat: -35.3554,
        lng: 149.0984,
        postcode: '2606'
    }, {
        name: 'Torrens',
        lat: -35.3737,
        lng: 149.0874,
        postcode: '2607'
    }, {
        name: 'Waramanga',
        lat: -35.3527,
        lng: 149.0603,
        postcode: '2611'
    }, {
        name: 'Weston Creek',
        lat: -35.3423,
        lng: 149.0523,
        postcode: '2611'
    }, {
        name: 'Downer',
        lat: -35.2433,
        lng: 149.1431,
        postcode: '2602'
    }, {
        name: 'Fadden',
        lat: -35.4037,
        lng: 149.1157,
        postcode: '2904'
    }, {
        name: 'Flynn',
        lat: -35.2051,
        lng: 149.0442,
        postcode: '2615'
    }, {
        name: 'Fraser',
        lat: -35.1922,
        lng: 149.0438,
        postcode: '2615'
    }, {
        name: 'Giralang',
        lat: -35.2130,
        lng: 149.0960,
        postcode: '2617'
    }, {
        name: 'Griffith',
        lat: -35.3262,
        lng: 149.1425,
        postcode: '2603'
    }, {
        name: 'Harrison',
        lat: -35.1942,
        lng: 149.1529,
        postcode: '2914'
    }, {
        name: 'Holt',
        lat: -35.2261,
        lng: 149.0121,
        postcode: '2615'
    }, {
        name: 'Isabella Plains',
        lat: -35.4285,
        lng: 149.0908,
        postcode: '2905'
    }, {
        name: 'Kingston',
        lat: -35.3138,
        lng: 149.1442,
        postcode: '2604'
    }, {
        name: 'Lyons',
        lat: -35.3401,
        lng: 149.0766,
        postcode: '2606'
    }, {
        name: 'Mawson',
        lat: -35.3621,
        lng: 149.0990,
        postcode: '2607'
    }, {
        name: 'Monash',
        lat: -35.4154,
        lng: 149.0921,
        postcode: '2904'
    }, {
        name: 'Nicholls',
        lat: -35.1837,
        lng: 149.0989,
        postcode: '2913'
    }, {
        name: 'Oxley',
        lat: -35.4064,
        lng: 149.0761,
        postcode: '2903'
    }, {
        name: 'Pearce',
        lat: -35.3633,
        lng: 149.0819,
        postcode: '2607'
    }, {
        name: 'Reid',
        lat: -35.2830,
        lng: 149.1417,
        postcode: '2612'
    }, {
        name: 'Scullin',
        lat: -35.2334,
        lng: 149.0396,
        postcode: '2614'
    }, {
        name: 'Symonston',
        lat: -35.3476,
        lng: 149.1581,
        postcode: '2609'
    }, {
        name: 'Tuggeranong',
        lat: -35.4210,
        lng: 149.0894,
        postcode: '2900'
    }, {
        name: 'Watson',
        lat: -35.2387,
        lng: 149.1543,
        postcode: '2602'
    }, {
        name: 'Wright',
        lat: -35.3191,
        lng: 149.0323,
        postcode: '2611'
    },
    {
        name: 'Braidwood',
        lat: -35.4500,
        lng: 149.8000,
        postcode: '2622'
    },
    {
        name: 'Bungendore',
        lat: -35.2562,
        lng: 149.4400,
        postcode: '2621'
    },
    {
        name: 'Crestwood',
        lat: -35.3487,
        lng: 149.2207,
        postcode: '2620'
    },
    {
        name: 'Googong',
        lat: -35.4240,
        lng: 149.2362,
        postcode: '2620'
    }, {
        name: 'Greenleigh',
        lat: -35.3683,
        lng: 149.2524,
        postcode: '2620'
    },
    {
        name: 'Jerrabomberra',
        lat: -35.3838,
        lng: 149.2006,
        postcode: '2619'
    },
    {
        name: 'Karabar',
        lat: -35.3764,
        lng: 149.2336,
        postcode: '2620'
    },
    {
        name: 'Nerriga',
        lat: -35.1191,
        lng: 150.0833,
        postcode: '2540'
    },
    {
        name: 'Queanbeyan',
        lat: -35.3500,
        lng: 149.2300,
        postcode: '2620'
    }, {
        name: 'Queanbeyan East',
        lat: -35.3470,
        lng: 149.2460,
        postcode: '2620'
    }, {
        name: 'Queanbeyan West',
        lat: -35.3581,
        lng: 149.2072,
        postcode: '2620'
    },
    {
        name: 'The Ridgeway',
        lat: -35.3408,
        lng: 149.2602,
        postcode: '2620'
    },
];


const suburbLocationList = [];
document.addEventListener('DOMContentLoaded', () => {
    const mapSection = document.querySelector('.shopify-section--service-map');
    if (mapSection) {
        const mapContainer = mapSection.querySelector('.map');
        if (mapContainer) {
            const postcodesContainer = mapSection.querySelector('.post-codes .postcode-list');
            const map = L.map(mapContainer.id).setView([-35.2809, 149.1300], 10);
            const customIcon = L.icon({
                iconUrl: mapContainer.getAttribute('marker_icon'),
                iconSize: [30, 30],
                iconAnchor: [12, 41]
            });
            const useDefaultIcon = mapContainer.getAttribute('useDefault');
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(map);
            // map.fitBounds(bounds);
            suburItems.forEach(suburbItem => {
                const marker = useDefaultIcon ? L.marker([suburbItem.lat, suburbItem.lng]).addTo(map) : L.marker([suburbItem.lat, suburbItem.lng], { icon: customIcon }).addTo(map);
                marker.bindPopup(`<div class="suburb-popup"><p>${suburbItem.name}</p><p>${suburbItem.postcode}</p></div>`);
                postcodesContainer.innerHTML += `
                    <div class="postcode-item" lat=${suburbItem.lat} lng=${suburbItem.lng}>
                        <p class='suburb-name m-0'>${suburbItem.name}</p>
                        <p class='suburb-postcode m-0'>${suburbItem.postcode}</p>
                    </div>
                `;
            });

            const postcodeSearch = mapSection.querySelector('.search');
            const postcodeInput = postcodeSearch.querySelector('input');
            const closeIcon = postcodeSearch.querySelector('img:last-child');
            let hTime = null;

            postcodeInput.addEventListener('keyup', (e) => {
                if (hTime !== null) {
                    clearInterval(hTime);
                    hTime = null;
                }
                hTime = setInterval(() => {
                    clearInterval(hTime);
                    hTime = null;
                    displaySuburbs(postcodesContainer, searchSuburb(suburItems, e.target.value));
                }, 500);
                if (e.target.value !== '') {
                    postcodeSearch.classList.remove('empty');
                } else {
                    postcodeSearch.classList.add('empty');
                }
            });
            closeIcon.addEventListener('click', () => {
                postcodeInput.value = '';
                displaySuburbs(postcodesContainer, suburItems);
            });

            const congratulationText = mapSection.querySelector('.congratulation-text');
            let hCongratulationTime = null;
            document.addEventListener('click', (e) => {
                let suburbItem = e.target.closest('.postcode-item');
                if (e.target.classList.contains('postcode-item')) {
                    suburbItem = e.target;
                }
                if (suburbItem) {
                    congratulationText.classList.add('show');
                    const lat = parseFloat(suburbItem.getAttribute('lat'));
                    const lng = parseFloat(suburbItem.getAttribute('lng'));
                    searchMarker(map, lat, lng);
                    if(hCongratulationTime !== null) {
                        clearInterval(hCongratulationTime);
                        hCongratulationTime = null;
                    }
                    hCongratulationTime = setInterval(() => {
                        congratulationText.classList.remove('show');
                        clearInterval(hCongratulationTime)
                    }, 5000);
                }
            });
        }
    }
});
const searchSuburb = (sourceList, pattern) => {
    const list = [];
    const lowerPattern = pattern.toLowerCase();
    sourceList.forEach(item => {
        if (item.name.toLowerCase().indexOf(lowerPattern) !== -1 || item.postcode.indexOf(lowerPattern) !== -1) {
            list.push(item);
        }
    });
    return list;
}
const displaySuburbs = (context, list) => {
    if (typeof context != 'object' || context.nodeName === '') {
        return;
    }
    context.innerHTML = '';
    list.forEach(item => {
        context.innerHTML += `
                    <div class="postcode-item" lat=${item.lat} lng=${item.lng}>
                        <p class='suburb-name m-0'>${item.name}</p>
                        <p class='suburb-postcode m-0'>${item.postcode}</p>
                    </div>
                `;
    });
}
const searchMarker = (map, lat, lng) => {
    let isFound = false;
    map.eachLayer((layer) => {
        if (isFound) {
            return;
        }
        if (layer instanceof L.Marker) {
            const pos = layer.getLatLng();
            if (pos.lat === lat && pos.lng === lng) {
                layer.openPopup(); // Open the popup
                map.panTo(layer.getLatLng());
                isFound = true;
            }
        }
    });
}